import _L from "../../../util/Labels";
import '../RadarProximity/RadarProximity';
import '../Slider/Slider';
import '../Switch/Switch';
import { customElement, property } from "lit/decorators.js";
import { html, LitElement, unsafeCSS } from "lit";
import { SwitchChangeDetail } from "../Switch/Switch";
import leafletStyles from 'leaflet/dist/leaflet.css?inline';
import styles from './RadarProximityConfig.scss?inline';


const colorArrive = 'var(--color_action1)';
const colorSchoolarZone = 'var(--color_app_pink1)';

@customElement('app-radar-proximity-config')
export class RadarProximityConfig extends LitElement {
    static styles = [unsafeCSS(leafletStyles), unsafeCSS(styles)];

    @property({ type: Boolean }) k_state: boolean = true;
    @property({ type: Number }) k_schoolLatitud: number | null = null;
    @property({ type: Number }) k_schoolLongitud: number | null = null;

    @property({ type: Number }) k_latitude: number | null = 0;
    @property({ type: Number }) k_longitude: number | null = 0;
    @property({ type: Number }) k_radioLlegada: number = 50;
    @property({ type: Number }) k_radioZonaEscolar: number = 250;
    @property({ type: Number }) k_llegadaMin: number = 50;
    @property({ type: Number }) k_llegadaMax: number = 120;
    @property({ type: Number }) k_zonaEscolarMin: number = 250;
    @property({ type: Number }) k_zonaEscolarMax: number = 500;

    private handleSwitchChange(e: CustomEvent<SwitchChangeDetail>) {
        const checked = e.detail.checked;
        this.k_state = checked;
    }

    render() {
        return html`
            <div class='proximity-cfg-wrapper'>
                <div class='switch-config'>
                    <app-switch
                        .checked=${this.k_state}
                        label=${_L("general.activate functionality")}
                        description=${_L("escuelas_proximidad.functionality_description")}
                        @switch-change=${this.handleSwitchChange}
                    >
                    </app-switch>
                </div>
                <label class='title'>${_L("escuelas_proximidad.zones_config")}</label>
                <div 
                    class='proximity-layout${this.k_state ? '' : ' disabled'}'
                    ?inhert=${this.k_state}
                >
                    <div class='radius-cfg'>
                        <div class='arrive-zone'>
                            <label>${_L("escuelas_proximidad.arrive_zone")}</label>
                            <app-slider
                                .k_value=${this.k_radioLlegada}
                                .k_min=${this.k_llegadaMin}
                                .k_max=${this.k_llegadaMax}
                                .k_disabled=${!this.k_state}
                                @slider-change=${(e: CustomEvent) => this.k_radioLlegada = e.detail.value}
                                style='--color-slider: ${colorArrive};'
                                >
                            </app-slider>
                        </div>   
                        <div class='schoolar-zone'>
                            <label>${_L("escuelas_proximidad.school_zone")}</label>
                            <app-slider
                                .k_value=${this.k_radioZonaEscolar}
                                .k_min=${this.k_zonaEscolarMin}
                                .k_max=${this.k_zonaEscolarMax}
                                .k_disabled=${!this.k_state}
                                @slider-change=${(e: CustomEvent) => this.k_radioZonaEscolar = e.detail.value}
                                style='--color-slider: ${colorSchoolarZone};'
                            ></app-slider>
                        </div>
                    </div>
                    <div class='radar-container'>
                        <app-radar-proximity
                            .k_schoolLatitud=${this.k_schoolLatitud}
                            .k_schoolLongitud=${this.k_schoolLongitud}
                            .k_latitude=${this.k_latitude}
                            .k_longitude=${this.k_longitude}
                            .k_radioLlegada=${this.k_radioLlegada}
                            .k_radioZonaEscolar=${this.k_radioZonaEscolar}
                            .k_radioLlegadaColor=${colorArrive}
                            .k_radioZonaEscolarColor=${colorSchoolarZone}
                            @location-changed=${this._handleLocationChange}
                        ></app-radar-proximity>
                    </div>
                </div>
            </div>
        `
    }

    private _handleLocationChange(e: CustomEvent) {
        this.k_latitude = e.detail.lat;
        this.k_longitude = e.detail.lng;
    }
}